import { render, staticRenderFns } from "./EndScreen.vue?vue&type=template&id=31be94c6&"
import script from "./EndScreen.vue?vue&type=script&lang=js&"
export * from "./EndScreen.vue?vue&type=script&lang=js&"
import style0 from "./EndScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports